/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import Cookies from 'js-cookie';
import { Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { usePageTitle } from '../../../../App';
import datagain_home_page_hero_img from '../../../../assets/images/datagain-home-page-hero-img.png';
import logo from '../../../../assets/images/logo.svg';
import { WEB_URL } from '../../../../constants/Config';
import { DASHBOARD_ROUTE, FORGOT_PASSWORD_ROUTE, LOGIN_ROUTE } from '../../../../constants/RouteNameConstants';
import {
  EMAIL_ID_MAX_VALID,
  EMAIL_ID_REQURIED,
  EMAIL_ID_VALID,
  PASSWORD_REQURIED,
  PASSWORD_VALID,
} from '../../../../constants/ValidationMessageConstants';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { userLoginRequest } from '../actions';
import { trackEvent } from '../../../../utils/ga';

const Login = () => {
  usePageTitle('Datagain Transcription  - Sign in'); // Set tab title

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const [showPassword, setShowPassword] = useState(false);
  const [cookieValue, setCookieValue] = useState(() => {
    const cookie = Cookies.get('userDataProofreader');
    return cookie ? JSON.parse(cookie) : null;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const cookie = Cookies.get('userDataProofreader');
      const currentCookieValue = cookie ? JSON.parse(cookie) : null;

      // Check for any change in the cookie data
      if (JSON.stringify(cookieValue) !== JSON.stringify(currentCookieValue)) {
        setCookieValue(currentCookieValue); // Update state
        if (currentCookieValue) {
          window.location.href = DASHBOARD_ROUTE; // Redirect to dashboard
        }
      }
    }, 1000); // Check every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [cookieValue, navigate]);

  useEffect(() => {
    if (userInfo) {
      navigate(DASHBOARD_ROUTE);
    }
  }, []);

  // Page in loading
  let loading = useSelector((state) => state?.loginUserData?.loading);

  const storedEmail = Cookies.get('emailProofreader') || '';
  const storedPassword = Cookies.get('passwordProofreader') || '';

  const initialValues = {
    email: storedEmail,
    password: storedPassword,
    rememberMe: !!storedEmail && !!storedPassword,
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .required(EMAIL_ID_REQURIED)
      .email(EMAIL_ID_VALID)
      .max(255, EMAIL_ID_MAX_VALID)
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, EMAIL_ID_VALID),
    password: Yup.string().matches(/\S/i, PASSWORD_VALID).required(PASSWORD_REQURIED),
  });

  const onSubmit = (data, { setSubmitting }) => {
    const loginRequestData = {
      email: data.email,
      password: data.password,
      rememberMe: data.rememberMe,
    };

    if (data.rememberMe) {
      Cookies.remove('emailProofreader');
      Cookies.remove('passwordProofreader');
      Cookies.set('emailProofreader', data.email, {
        expires: 7,
        secure: true,
      });
      Cookies.set('passwordProofreader', data.password, {
        expires: 7,
        secure: true,
      });
    } else {
      Cookies.remove('emailProofreader');
      Cookies.remove('passwordProofreader');
    }

    trackEvent('proofreader_login', {
      email: data.email,
    });

    dispatch(userLoginRequest(loginRequestData));
    setSubmitting(false);
  };

  return (
    <div className="d-flex vh-100 w-100 flex-column overflow-y-auto bg-lighter">
      <div className="d-flex flex-grow-1 align-items-center justify-content-center py-4">
        <div className="login-card shadow-sm">
          <div className="form-group mb-3 text-center">
            <div className="mb-3">
              <Link to={LOGIN_ROUTE}>
                <img src={logo} alt="logo" className="img-fluid logo-img" />
              </Link>
            </div>
            <h1 className="form-title text-center mb-0">Welcome to ant by Datagain</h1>
            <p className="font-weight-normal opacity-50">High quality transcription & analysis</p>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validateOnBlur={false}
            validateOnChange={false}
          >
            <Form>
              <label className="form-label fnt-14 fw-normal">Email</label>
              <div className="form-group mb-3 position-relative">
                <Field
                  name="email"
                  type="text"
                  placeholder="Enter email address"
                  className="w-100 form-control"
                  autoComplete="off"
                />
                <div className="input-group-icon">
                  <LocalPostOfficeOutlinedIcon />
                </div>
                <ErrorMessage name="email" component="div" className="invalid-feedback" />
              </div>
              <label className="form-label fnt-14 fw-normal">Password</label>
              <div className="form-group mb-3 position-relative">
                <Field
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  className="w-100 form-control"
                  autoComplete="off"
                />
                <div className="input-group-icon cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                </div>
                <ErrorMessage name="password" component="div" className="invalid-feedback" />
              </div>
              <div className="form-group mb-3 d-flex align-items-center justify-content-between fnt-14">
                <div className="d-flex">
                  <Field id="rememberMe" name="rememberMe" type="checkbox" className="form-check-input" />
                  <label htmlFor="rememberMe" style={{ marginLeft: '6px' }}>
                    Remember Me
                  </label>
                </div>
                <Link to={FORGOT_PASSWORD_ROUTE} className="link-color">
                  Forgot Password
                </Link>
              </div>
              <div className="d-grid gap-2 mt-3">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  ) : (
                    'Login'
                  )}
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Login;
